export function createSlug(title) {
  return title
    .toLowerCase() // Convertit en minuscules
    .normalize("NFD").replace(/[\u0300-\u036f]/g, '') // Supprime les accents
    .replace(/[^a-z0-9 -]/g, '') // Supprime les caractères spéciaux
    .replace(/\s+/g, '-') // Remplace les espaces par des tirets
    .replace(/-+/g, '-') // Évite les tirets en double
    .trim(); // Supprime les espaces inutiles
}
